import { VBtn } from 'vuetify/lib/components/VBtn';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VMenu,{attrs:{"nudge-top":"10","nudge-left":"5","top":"","offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c(VBtn,_vm._g({staticClass:"language-switcher"},on),[_c('span',[_vm._v(" "+_vm._s(_vm.languageName)+" ")])])]}}])},[_c(VList,_vm._l((_vm.languages),function(lang){return _c(VListItem,{key:lang.code,on:{"click":function($event){return _vm.selectLanguage(lang.code)}}},[_c(VListItemTitle,[_c('span',[_vm._v(_vm._s(lang.name))])])],1)}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }